import React, { useEffect, useState } from "react";
import { IS_WEB } from "@services/Config";
import UnityMarker from "../../../components/UnityMarker";
import useMapUnitys from "../../../hooks/useMapUnitys";

export default function UnityMarkers({
  coordinate,
  radiosCircle,
  onPressMarker,
}) {
  const [jsonUnitiesMap, setJsonUnitiesMap] = useState(null);
  const { data, isLoading, isSuccess } = useMapUnitys(coordinate.marker, 0);

  useEffect(() => {
    if (isSuccess) {
      setJsonUnitiesMap(data);
    }
  }, [isSuccess]);

  // Don't render map components on web
  if (IS_WEB || !jsonUnitiesMap) return null;

  return (
    <>
      {jsonUnitiesMap != null ? (
        jsonUnitiesMap.map((unity) => {
          if (unity.latitude != undefined && unity.longitude != undefined) {
            return (
              <UnityMarker
                mapRegion={{
                  latitude: unity.latitude,
                  longitude: unity.longitude,
                }}
                key={unity.id}
                nameUnity={unity.address.toUpperCase()}
                address={unity.address}
                onPress={() => {
                  onPressMarker(
                    unity.name,
                    unity.address,
                    unity.openingHours,
                    unity.paymentMethods,
                    unity.latitude,
                    unity.longitude
                  );
                }}
              />
            );
          }
          return null;
        })
      ) : null}
    </>
  );
}
